import { BuildingDetail } from "./BuildingDetail";
import { Header } from "./Header";
import { OutboundLink } from "./Map";

const byline = JSON.parse(process.env.REACT_APP_AUTHOR);

export const formatDate = (rawDate) => {
  const options = {
    month: "long",
    day: "numeric",
    year: "numeric",
  };
  const date = new Date(rawDate.slice(0, 10).replace(/-/g, "/"));
  const dateFormatted = date.toLocaleDateString("en-us", options);
  return dateFormatted;
};

export const Overlay = ({ selectedBuilding, referrer }) => (
  <div className="map-overlay" id="main-map-overlay">
    <Header referrer={referrer} />
    <h2 className="chart-title">
      Here Are the Buildings Reporting Fewer Regulated Apartments
    </h2>
    <span className="chart-note byline-content">
      By{" "}
      {byline.map((author, i) => (
        <span key={i} className="author">
          <OutboundLink to={author.url} referrer={referrer}>
            {author.name}
          </OutboundLink>
          {i < byline.length - 2 ? ", " : i < byline.length - 1 ? " and " : ""}
        </span>
      ))}
    </span>
    <span className="chart-note byline-content">
      Updated: {formatDate(process.env.REACT_APP_UPDATE_DATE)}
    </span>
    <p className="chart-dek ml-0">
      New data from housing group{" "}
      <OutboundLink
        to="https://www.justfix.org/en/?utm_source=thecity"
        referrer={referrer}
      >
        JustFix
      </OutboundLink>{" "}
      shows thousands of New York City apartments unlisted as rent-stabilized —
      even after a 2019 law required continued controls with few exceptions.{" "}
      <OutboundLink to="https://www.thecity.nyc/?p=32726" referrer={referrer}>
        Related Story
      </OutboundLink>
    </p>
    <div className="map-geocoder-placeholder" />
    <BuildingDetail selectedBuilding={selectedBuilding} referrer={referrer} />
  </div>
);
